import { showBillingPopup } from '@/common/utils/common'
import constant from '@/common/resources/constant'
import { parseUrl } from 'query-string'

export const setGoDetailUrl = (url = '') => {
  const { query } = parseUrl(url)

  if (!url) {
    return ''
  }

  if (url.includes('purchasewebview')) {
    const locationOrigin =
      window.location.protocol + '//' + window.location.hostname
    showBillingPopup({
      productId: query.value?.productId ?? '',
      productType: 'all',
      returnUrl: constant.URL_PROTOCOL_WITH_DOMAIN,
      canceledUrl: `${locationOrigin}/callback.html?action=Cancel`,
    })
    return null
  }

  if (url.includes('member.')) {
    window.open(`https://${url}`, '_blank')
    return null
  }

  if (url.includes('notice_view')) {
    return url
  }

  if (url.includes('theme-contents')) {
    const themeId = query.value?.themeid ?? ''
    return `/list/EN${themeId}`
  }

  if (url === '/voucher/index.html') {
    return '/voucher/index'
  }

  if (url === '/voucher/recommend.html') {
    return '/voucher/recommend'
  }

  return url
}
